
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   记账管理
                </span>
               
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>

               <div>
                   <p class="text-center" style="font-size:20px;">
                       已记账信息
                   </p>
               </div>

              <div>
                    
                    <div class="opt-letter-watch-box ml-4" style="float:left;">
                        <a class="bt-button personal-letter yjz" @click="wjz()">
                            查询未记账
                        </a>
                    </div>
                    <div class="opt-letter-watch-box ml-2" style="float:left;" @click="dz()">

                        <a class="bt-button personal-watch yjz">
                            查询对账
                        </a>
                    </div>
              </div>

              <div class="mt-4" style="display:flex;font-size:15px;">

                  <div class="ml-2"> 
                       <span>序列号:</span>
                       <input type="text" class="input_form-control" v-model="searchForm.Xlh" @keydown.enter="searchEnterFun">
                  </div>
                   
                  <div class="ml-2"> 
                       <span>客户名称:</span>
                       <input type="text" class="input_form-control" v-model="searchForm.Khmc" @keydown.enter="searchEnterFun">
                  </div>
                   <div class="ml-3" style="line-height:28px;"> 
                       <span>开始时间:</span>
                       <date  style="float:right;margin-top:2px;" @changeDate="changeDate1($event)"/>
                  </div>
                   <div class="ml-3" style="line-height:28px;"> 
                       <span>结束时间:</span>
                       <date style="float:right;margin-top:2px;" @changeDate="changeDate2($event)"/>
                  </div>

                  <div class="ml-4 opt-letter-watch-box1">
                        <a class="bt-button personal-watch yjz" @click=" getClerkStoreGoodsQuery(1)">
                            查询
                        </a>
                  </div>

                  
              </div>

            
              
            <div v-if="showPage" class="mt-2">

          

           
            <table  class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>发货单号</th>
                        <th>序列号</th>
                        <th>提交人</th>
                        <th>记账方式</th>
                        <th>客户编号</th>
                        <th>客户名称</th>
                        <th>物流</th>
                        <th>订单备注</th>
                        <th>收货人</th>
                        <th>换票方式</th>
                        <th>提交时间</th>
                        <th>记账时间</th>
                        <th>发货</th>
                        <th>订单到期时间</th>
                        <th>客户备注</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.fhdh}}</td>
                              <td class="jz_middle">{{item.xlh}}</td>
                              <td class="jz_middle">{{item.yjztjr}}</td>
                              <td class="jz_middle">{{item.jzfs}}</td>
                              <td class="jz_middle">{{item.khbh}}</td>
                              <td class="jz_middle">{{item.khmc}}</td>
                              <td class="jz_middle">{{item.wl}}</td>
                              <td class="jz_middle">{{item.ordersmark}}</td>
                              <td class="jz_middle">{{item.shr}}</td>
                              <td class="jz_middle">{{item.hpfs}}</td>
                              <td class="jz_middle">{{item.inserttime | formatUTC}}</td>
                              <td class="jz_middle">{{item.jzsj | formatUTC}}</td>
                              <td class="jz_middle">{{item.isby}}</td>
                              <td class="jz_middle">{{item.xdsj | formatUTC}}</td>
                              <td class="jz_middle">{{item.mark}}</td>
                      </tr>
                    </tbody>
                  </table>

                    <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                    </div>
                 </div>

                  <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->
                   

           
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import { async } from 'q';
import date from '../../components/Date.vue'
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          Xlh:"",
          Khmc:"",
         DateMoreThan: '',
          DateLessThan: '' ,
            DateLessThan1: '',
          DateMoreThan1: '',
        },

      
        isLoading: false,
        count:"",
        tableData: [],
        showPage:false,
        details:[],
        totalLimitMoney:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components:{
        vPagination,
        date
    },
    computed:{
         
},
filters: {
 
 
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
    
},

methods: {

     searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },


       // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
               getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
  


      //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
          this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
          // console.log(time)
          this.searchForm.DateMoreThan1=date;
      },
      

    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {

         //获取三个月前的时间戳   时间条件适合才可以查询

         const that = this

         let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();
    //    console.log(seTime2)
        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{
     
      
          // this.isLoading=true;
        const { data: res } = await that.$http.post('DsApi/DsGetfun', {
          action: 'DsapiManagemen',
          obj: JSON.stringify({
             jztype:1,
              pageIndex:PageIndex,
              startTime:that.searchForm.DateLessThan1,
              endTime:that.searchForm.DateMoreThan1,
              xlh:that.searchForm.Xlh.trim(),
              khmc:that.searchForm.Khmc.trim(),
          }) 
        })
         console.log(res)
           if(res.isok){
                const obj=res.data
                that.tableData = obj.rows
                 that.total = obj.record
                 that.count = obj.count
                if(that.tableData.length>0)
                {

                    that.showPage=true;
                   
                }
                else{
                    that.showPage =false;
                }
             
           }
        }
        

       
         
      },
     pagechange:function(currentPage){
     

           this.getClerkStoreGoodsQuery(currentPage);
         
     },

       dz(){
             this.$router.push({path: '/checkAccount'})
       },
       wjz(){
             this.$router.push({path: '/accounts'})
       }

  
    },
     mounted(){
    },
     created () {
         
     this.searchForm.DateMoreThan=this.getDay1(0)
      this.searchForm.DateLessThan=this.getDay1(0)
       this.searchForm.DateLessThan1=this.getDay(0)
      this.searchForm.DateMoreThan1=this.getDay(0)
  
        this.getClerkStoreGoodsQuery(1);
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;

  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .opt-letter-watch-box {
    color: #f5a523;
    font-size: 12px;
    width: 126px;
    height: 28px;
    border-radius: 14px;
    line-height: 26px;
 
}
.personal-letter {
    border: 1px solid #fc5531;
    background-color: #fff;
    color: #fc5531!important;
    line-height: 28px;
    border-radius: 14px;
}
.bt-button {
    display: block;
    border-radius: 14px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
    font-size: 14px;
    text-align:center;
}
.yjz{
    cursor: pointer;
}
.personal-watch {
    background: linear-gradient(92deg,#ffba40 0%,#ff503e 37%,#ff2f50 81%,#ff1b40 100%);
    color: #fff !important;
    line-height: 26px;
    border-radius: 14px;
}
.opt-letter-watch-box1 {
    color: #f5a523;
    font-size: 12px;
    width: 80px;
    height: 28px;
    border-radius: 14px;
    line-height: 26px;
 
}
.input_form-control { 
/* // display: block;  */
width: 70%; 
height: 28px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}

</style>


// WEBPACK FOOTER //
// src/pages/Administrator/HaveAccount.vue